import { render, staticRenderFns } from "./CartItemSmall.vue?vue&type=template&id=b3231d20&scoped=true"
import script from "./CartItemSmall.vue?vue&type=script&lang=js"
export * from "./CartItemSmall.vue?vue&type=script&lang=js"
import style0 from "./CartItemSmall.vue?vue&type=style&index=0&id=b3231d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3231d20",
  null
  
)

export default component.exports